/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as sis from './SISApp'
import { componentApi, loadTranslations } from 'common'


export class K12HallpassStuhallpassesApi {
  async LoadData(ssyGU : string, onlyOverTimeLimit : boolean, showMore : boolean, timeframeStr : string, svue : boolean) : Promise<sis.StudentHallPassesData> {
    return await componentApi.call('sis', 'k12-hallpass-stuhallpasses', 'K12HallpassStuhallpassesApi', 'LoadData', {
      ssyGU,
      onlyOverTimeLimit,
      showMore,
      timeframeStr,
      svue,
    });
  }
}
export default new K12HallpassStuhallpassesApi()
